import { render } from "./dondeycuando_ingles.vue?vue&type=template&id=4b50e906&scoped=true"
import script from "./dondeycuando_ingles.vue?vue&type=script&lang=js"
export * from "./dondeycuando_ingles.vue?vue&type=script&lang=js"

import "./dondeycuando_ingles.vue?vue&type=style&index=0&id=4b50e906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b50e906"]])

export default __exports__